<div class="container">
    <h1 class="principal-title">Oportunidades</h1>
    <div class="principal-summary">Una oportunidad es una condición o evento que favorece el proceso de
        construcción de futuro deseable para el bienestar de la población o el desarrollo nacional, siempre y cuando se
        tomen las decisiones adecuadas y oportunas para su aprovechamiento. A continuación, seleccione alguna
        oportunidad según unidad territorial para obtener mayor información.
    </div>
    <app-carousel [idEventTypeForSlider]="idEvenType"></app-carousel>
    <div class="container-button">
        <div class="row">
            <div class="col-md-6 mb-3 mb-md-0">
                <a class="btn-foi" *ngIf="t1 && t1.urllistado" href="{{URL}}{{t1.urllistado}}" target="_blank">
                    <i class="fa fa-file-pdf-o icon-pdf"></i>Listado de oportunidades
                </a>
            </div>
            <div class="col-md-6">
                <app-search-contextual [idEvenType]="idEvenType"></app-search-contextual>
            </div>
        </div>
    </div>

    <div class="normal-text"> A continuación, seleccione alguna oportunidad para obtener mayor
        información.
    </div>
    <br>

    <div class="row text-center mb-5" style="display: flex; flex-direction: row; justify-content: center;">
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../oportunidad-global">
            <img class="img-trends tg" src="assets/img/t/tg-w.webp" alt="">
            <br>Oportunidades globales y nacionales</a>
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../oportunidad-territorial">
            <img class="img-trends tt" src="assets/img/t/tt-w.webp" alt="">
            <br>Oportunidades territoriales</a>
    </div>

    <div class="row text-Blue">
        * Revisar documento metodológico sobre oportunidades
        <a *ngIf="t1 && t1.urlmetodologico" href="{{URL}}{{t1.urlmetodologico}}" target="_blank">aquí</a>
    </div>

</div>